var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.profile.id
    ? _c(
        "div",
        [
          _c(
            "el-dialog",
            {
              ref: "missingDevice",
              attrs: {
                title: "Missing Device",
                fullscreen: true,
                visible: _vm.openMissingDevice,
                "before-close": _vm.handleClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.openMissingDevice = $event
                },
              },
            },
            [
              _c("Troubleshooting", {
                attrs: { data: _vm.troubleshootingData },
              }),
              _vm._v(" "),
              _c("el-alert", {
                attrs: {
                  "data-test": "alert-header",
                  closable: false,
                  type: "error",
                  "show-icon": "",
                  title: _vm.alertTitle,
                  center: "",
                },
              }),
              _vm._v(" "),
              _vm.devProfile.created_at
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        margin: "10px 0px",
                        "text-align": "center",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-date" }),
                      _vm._v(
                        " Device created on " +
                          _vm._s(
                            _vm._f("moment")(
                              _vm.devProfile.created_at,
                              "DD MMMM, YYYY HH:MM A"
                            )
                          ) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "device-info" }, [
                      _c("div", { staticClass: "profile-missing-row" }, [
                        _c("label", [_vm._v("Device ID")]),
                        _vm._v(" "),
                        _c("div", [
                          _c("b", [_vm._v(_vm._s(_vm.devProfile.device_id))]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "profile-missing-row" }, [
                        _c("label", [_vm._v("Product Type")]),
                        _vm._v(" "),
                        _c("div", [
                          _c("b", [_vm._v(_vm._s(_vm.devProfile.kind))]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "profile-missing-row" }, [
                        _c("label", [_vm._v("Serial Number (DSN)")]),
                        _vm._v(" "),
                        _c("div", [
                          _c("b", [
                            _vm._v(_vm._s(_vm.devProfile.serial_number)),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "profile-missing-row" }, [
                        _c("label", [_vm._v("Product description")]),
                        _vm._v(" "),
                        _c("div", [
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.product ? _vm.product.description : "N/D"
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "profile-missing-row" }, [
                        _c("label", [_vm._v("State")]),
                        _vm._v(" "),
                        _c("div", [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm._f("capitalize")(_vm.deviceState))
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "profile-missing-row" }, [
                        _c("label", [_vm._v("Retailer Name")]),
                        _vm._v(" "),
                        _c("div", [
                          _c("b", [_vm._v(_vm._s(_vm.retailerName))]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "profile-missing-row" }, [
                        _c("label", [_vm._v("Retailer Xline")]),
                        _vm._v(" "),
                        _c("div", [
                          _c("b", [_vm._v(_vm._s(_vm.retailerXline))]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "profile-missing-row" }, [
                        _c("label", [_vm._v("Current Stock")]),
                        _vm._v(" "),
                        _c("div", [
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.devProfile.current_stock || "Fresh Lot"
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "device-actions" }, [
                      _c(
                        "div",
                        { staticClass: "button-row" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "Replacement unavailable for this device",
                                disabled: !_vm.isReplacementDisabled,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    disabled: _vm.isReplacementDisabled,
                                    "data-test": "replacement-button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openReplacementForm()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Start Replacement\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "button-row" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "Refund unavailable for this device",
                                disabled: !_vm.isRefundDisabled,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    disabled: _vm.isRefundDisabled,
                                    "data-test": "refund-button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openForm("refund")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Start Refund\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "button-row" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "Parts unavailable for this device",
                                disabled: !_vm.isPartsDisabled,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    disabled: _vm.isPartsDisabled,
                                    "data-test": "parts-button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openForm("parts")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Start Parts\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("el-alert", {
                attrs: {
                  title: "Current Requests",
                  type: "info",
                  closable: false,
                },
              }),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.devProfile.requests, width: "100%;" } },
                [
                  _c("el-table-column", {
                    attrs: { label: "Type" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.type.split("::")[1]) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1854095567
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { property: "uuid", label: "UUID" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { property: "state", label: "State" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { property: "customer_email", label: "Customer" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.device
            ? _c("replacement-modal-form", {
                ref: "replacement",
                attrs: { device: _vm.device },
                on: {
                  "closed-form": function ($event) {
                    return _vm.reloadDeviceRequests()
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.device
            ? _c("parts-modal-form", {
                ref: "parts",
                attrs: { device: _vm.device },
                on: {
                  "closed-form": function ($event) {
                    return _vm.reloadDeviceRequests()
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.device
            ? _c("refund-modal-form", {
                ref: "refund",
                attrs: { device: _vm.device },
                on: {
                  "closed-form": function ($event) {
                    return _vm.reloadDeviceRequests()
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.device && _vm.newReplacementFormVisible
            ? _c("replacement-form", {
                ref: "replacement",
                attrs: {
                  visible: _vm.newReplacementFormVisible,
                  "is-supervisor": _vm.isSupervisor,
                  device: _vm.device,
                  "missing-device-eligibility": _vm.eligibility,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.newReplacementFormVisible = $event
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }